import { Controller } from "@hotwired/stimulus"

// 입력 포맷 컨트롤러
// 사업자등록번호, 전화번호 등 특정 형식의 입력만 허용
export default class extends Controller {
  static targets = ["input"]
  static values = {
    pattern: String // 'business-number', 'phone', 'number-only'
  }

  // 입력값 포맷팅
  format(event) {
    const input = event.target
    let value = input.value

    switch (this.patternValue) {
      case 'business-number':
        // 숫자와 - 만 허용
        value = value.replace(/[^0-9-]/g, '')
        break

      case 'phone':
        // 숫자와 - 만 허용
        value = value.replace(/[^0-9-]/g, '')
        break

      case 'number-only':
        // 숫자만 허용
        value = value.replace(/[^0-9]/g, '')
        break

      default:
        break
    }

    input.value = value
  }
}
